/**
 * Mart v2, phase 8: a supplier statement per BRANCH. The API names each payment's branch
 * (`branch_name`, `supplier_branch_id` — 0 is the main branch). A branch employee only ever gets
 * their own branch's statements, so the branch is shown only when the list holds several.
 *
 * Kept in its own tiny module so it is unit-testable without the row's intl / api / modal graph.
 */
export interface IPaymentBranchFields {
  supplier_branch_id?: number | null
  branch_name?: string | null
}

/** Do the listed statements belong to more than one branch? */
export function showsSeveralBranches(items: IPaymentBranchFields[]): boolean {
  return new Set(items.map((item) => Number(item.supplier_branch_id ?? 0))).size > 1
}

/** The statement export's file name: its period, and its branch when the list shows branches. */
export function paymentDetailsFileName(periodName: string, item: IPaymentBranchFields, showBranch: boolean): string {
  const branch = showBranch ? (item.branch_name ?? '').trim().replace(/[\\/:*?"<>|\s]+/g, '-') : ''

  return `PaymentDetails_${periodName}${branch ? `_${branch}` : ''}.xlsx`
}
